// import React from 'react';
import React, { useState, useEffect } from 'react';

import {
  Row, Card, Col, Spin, Breadcrumb,
} from 'antd';

import { useParams, Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import devicesApi from '@api/devicesApi';

import { useTranslation } from 'react-i18next';

import CenteredContent from '@common/components/ui/CenteredContent';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMicrochip } from '@fortawesome/free-solid-svg-icons';
import styles from './BusinessType.module.less';

function BusinessType() {

  const { t } = useTranslation();
  const [sw, setSew] = useState(true);
  const [businessType, setBusinessType] = useState(true);
  const businessTypeInfo = useSelector(({ telemetry: tel }) => tel.generalBusinessTypeInfo);

  const getBusinessType = () => {

    setSew(true);

    const item = {
      id: businessTypeInfo?.id || '',
      title: businessTypeInfo?.name || '',
      logo_full_url: businessTypeInfo?.logo_full_url || '',
      description: businessTypeInfo?.description || '',
      type: businessTypeInfo?.type || '',
      total_general: businessTypeInfo?.total_general || 0,
      total_conecy: businessTypeInfo?.total_conecy || 0,
    };

    setBusinessType(item);

    setSew(false);

  };

  useEffect(() => {

    if (businessTypeInfo?.id) {

      getBusinessType(businessTypeInfo);

    }

  }, [businessTypeInfo]);

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
      {
        sw ? <Spin tip={t('views.device_graphics.loading_data_graphs')} />
          : (
            <Card style={{ width: '100%', height: '100%' }}>
              <Row gutter={[16, 8]} style={{ fontSize: 20, fontWeight: 'bold', marginBottom: 10 }}>
                <Col span={8} className="text-right" style={{ color: '#8c8c8c', fontSize: 24, fontWeight: 'bold' }}>
                  <div className={styles.circle_icon_container}>
                    {businessType?.logo_full_url && businessType?.logo_full_url !== ''
                      ? (
                        <img
                          src={businessType.logo_full_url}
                          alt={businessType.title}
                          className="image-logo-busines-detail"
                        />
                      )
                      : (
                        <FontAwesomeIcon icon={faMicrochip} style={{ fontSize: 20, color: '#ffffff' }} />
                      )}
                  </div>
                </Col>
                <Col span={16}>
                  <Row style={{ color: '#8c8c8c', fontSize: 24, fontWeight: 'bold' }}>
                    {businessType.title}
                  </Row>
                  <Row style={{ fontSize: '14px', color: '#8c8c8c' }}>
                    <Breadcrumb className="date_wrapper">
                      <Breadcrumb.Item className="breadcrumb">
                        <Link to="/">{t('menu_items.main.home')}</Link>
                      </Breadcrumb.Item>
                      <Breadcrumb.Item className="breadcrumb">
                        <Link to="/">{t('views.create_business_type.business')}</Link>
                      </Breadcrumb.Item>
                      <Breadcrumb.Item className="breadcrumb">
                        {businessType.title}
                      </Breadcrumb.Item>
                    </Breadcrumb>
                  </Row>
                </Col>
              </Row>
              <div>
                <p className="text-center" style={{ color: '#8c8c8c' }}>
                  {businessType.description}
                </p>
                <div className="text-center" style={{ padding: 10, borderRadius: 10 }}>
                  <span style={{ fontSize: 14, fontWeight: 'bold', margin: '0 0.5rem' }}>
                    {t('common.type')} :
                    {' '}
                    {businessType.type || ''}
                  </span>
                  <span style={{ fontSize: 14, fontWeight: 'bold', margin: '0 0.5rem' }}>
                    Total:
                    {' '}
                    {businessType.total_general}
                  </span>
                  <span style={{ fontSize: 14, fontWeight: 'bold', margin: '0 0.5rem' }}>
                    Conectados:
                    {' '}
                    {businessType.total_conecy}
                  </span>
                </div>
              </div>
            </Card>
          )
      }

    </div>
  );

}

export default BusinessType;
